
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        kecamatan: "",
        nama: "",
        phms: "",
        jenis: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0,
        l: 0,
        m: 0,
        n: 0,
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    // subTotalCols() {
    //   const cols = this.indikatorSchema.table.sumColumns;
    //   const rows = this.normalizedCetakRows;

    //   const totals = {};

    //   cols.forEach((c) => (totals[c] = 0));

    //   rows.forEach((r) => {
    //     cols.forEach((c) => {
    //       totals[c] += Number(r[c] || 0);
    //     });
    //   });

    //   return totals;
    // },

    nonSumColCount() {
    const body = this.indikatorSchema.table.bodyColumns
    const sumCols = this.indikatorSchema.table.sumColumns || []

    let count = 0

    for (let col of body) {
      if (sumCols.includes(col) || col === 'percentage') {
        break
      }
      count++
    }

    return count
  },

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      // 👉 Hitung percentage dari total A dan total B
      let percentage = 0;

      const id = this.form?.indikator?.id;

      if (id == 1) {
        percentage =
          totals.b > 0 ? (((totals.a - totals.b) / totals.b) * 100).toFixed(2) : 0;
      } else if (id == 10 || id == 12) {
        percentage =
          totals.a > 0
            ? ((totals.b / totals.a) * 100).toFixed(2)
            : 0;
      } else if (id == 16) {
        const numerator = totals.a + totals.b + totals.c;
        const denominator = totals.d + totals.e + totals.f;

        percentage =
          denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : 0;
      } else if (id == 26) {
        const numerator = totals.c + totals.d;
        const denominator = totals.a + totals.b;

        percentage =
          denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : 0;
      } else {
        percentage =
          totals.b > 0 ? ((totals.a / totals.b) * 100).toFixed(2) : 0;
      }

      totals.percentage = percentage;

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1 || id === 4 || id === 7) {
        let namaKomoditas = "";

        if (id === 1) {
          namaKomoditas = "Jenis Tanaman Pangan";
        } else if (id === 4) {
          namaKomoditas = "Komoditas Hortikultura";
        } else if (id === 7) {
          namaKomoditas = "Komoditas Peternakan";
        }
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: namaKomoditas },
                { label: "Produksi Tahun N-1 (Ton)" },
                { label: "Produksi Tahun N (Ton)" },
                { label: "Selisih (Ton)" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "a", "b", "selisih", "keterangan"],
            sumColumns: ["a", "b","selisih"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: namaKomoditas,
                    type: "text",
                  }
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Produksi Tahun N-1 (Ton)",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Produksi Tahun N (Ton)",
                    type: "text",
                  }
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              selisih: b - a,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2 || id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2 },
                { label: "Padi", colspan: 2 },
                { label: "Jagung", colspan: 2 },
                { label: "Ubi Kayu", colspan: 2 },
                { label: "Ubi Jalar", colspan: 2 },
                { label: "Kedelai", colspan: 2 },
                { label: "Kacang Tanah", colspan: 2 },
                { label: "Kacang Hijau", colspan: 2 },
                { label: "Total", rowspan: 2 },
                { label: "Keterangan", rowspan: 2 },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Luas Panen" },
                { label: "Produksi" },
                { label: "Luas Panen" },
                { label: "Produksi" },
                { label: "Luas Panen" },
                { label: "Produksi" },
                { label: "Luas Panen" },
                { label: "Produksi" },
                { label: "Luas Panen" },
                { label: "Produksi" },
                { label: "Luas Panen" },
                { label: "Produksi" },
                { label: "Luas Panen" },
                { label: "Produksi" },
              ],
            ],

            bodyColumns: ["kecamatan", "a", "b", "c","d", "e", "f","g", "h", "i","j", "k","l","m","n","total", "keterangan"],
            sumColumns: ["a", "b", "c","d", "e", "f","g", "h", "i","j","k","l","m","n", "total"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title : 'Padi',
                cols: 2,
                fields: [
                  { key: "a",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Jagung',
                cols: 2,
                fields: [
                  { key: "c",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "d",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Ubi Kayu',
                cols: 2,
                fields: [
                  { key: "e",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "f",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Ubi Jalar',
                cols: 2,
                fields: [
                  { key: "g",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "h",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Kedelai',
                cols: 2,
                fields: [
                  { key: "i",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "j",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Kacang Tanah',
                cols: 2,
                fields: [
                  { key: "k",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "l",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Kacang Hijau',
                cols: 2,
                fields: [
                  { key: "m",
                    label: "Luas Panen",
                    type: "text",
                  },
                  {
                    key: "n",
                    label: "Produksi",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);
            const g = num(row.g);
            const h = num(row.h);
            const i = num(row.i);
            const j = num(row.j);
            const k = num(row.k);
            const l = num(row.l);
            const m = num(row.m);
            const n = num(row.n);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              g,
              h,
              i,
              j,
              k,
              l,
              m,
              n,
              total : b + d + f + h + j + l + n,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5 || id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3 },
                { label: "Produksi Komoditas Hortikultura", colspan: 9 },
                { label: "Keterangan", rowspan: 3 },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Buah", colspan: 4 },
                { label: "Sayuran", colspan: 5 },
              ],
              [
                { label: "Buah Naga" },
                { label: "Durian" },
                { label: "Jeruk Siam" },
                { label: "Nanas" },
                { label: "Bawang Merah" },
                { label: "Cabai Besar" },
                { label: "Cabai Rawit" },
                { label: "Tomat" },
                { label: "Jahe" },
              ],
            ],

            bodyColumns: ["kecamatan", "a", "b", "c","d", "e", "f","g", "h", "i", "keterangan"],
            sumColumns: ["a", "b", "c","d", "e", "f","g", "h", "i"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title : 'Buah',
                cols: 4,
                fields: [
                  { key: "a",
                    label: "Buah Naga",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Durian",
                    type: "text",
                  },
                  { key: "c",
                    label: "Jeruk Siam",
                    type: "text",
                  },
                  {
                    key: "d",
                    label: "Nanas",
                    type: "text",
                  },
                ],
              },
              {
                title : 'Sayuran',
                cols: 2,
                fields: [
                  { key: "e",
                    label: "Bawang Merah",
                    type: "text",
                  },
                  {
                    key: "f",
                    label: "Cabai Besar",
                    type: "text",
                  },
                ],
              },
              {
                cols: 3,
                fields: [
                  { key: "g",
                    label: "Cabai Rawit",
                    type: "text",
                  },
                  {
                    key: "h",
                    label: "Tomat",
                    type: "text",
                  },
                  { key: "i",
                    label: "Jahe",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);
            const g = num(row.g);
            const h = num(row.h);
            const i = num(row.i);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              g,
              h,
              i,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 8 || id === 9) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2 },
                { label: "Komoditas Peternakan", colspan: 9 },
                { label: "Keterangan", rowspan: 2 },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Sapi Potong" },
                { label: "Kerbau" },
                { label: "Kambing" },
                { label: "Babi" },
                { label: "Ayam Buras" },
                { label: "Ayam Petelur" },
                { label: "Ayam Pedaging" },
                { label: "Itik" },
                { label: "Itik Manila" }
              ],
            ],

            bodyColumns: ["kecamatan", "a", "b", "c","d", "e", "f","g", "h", "i", "keterangan"],
            sumColumns: ["a", "b", "c","d", "e", "f","g", "h", "i"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title : 'Komoditas Peternakan',
                cols: 3,
                fields: [
                  { key: "a",
                    label: "Sapi Potong",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Kerbau",
                    type: "text",
                  },
                  { key: "c",
                    label: "Kambing",
                    type: "text",
                  },
                  {
                    key: "d",
                    label: "Babi",
                    type: "text",
                  },
                  { key: "e",
                    label: "Ayam Buras",
                    type: "text",
                  },
                  {
                    key: "f",
                    label: "Ayam Petelur",
                    type: "text",
                  },
                  { key: "g",
                    label: "Ayam Pedaging",
                    type: "text",
                  },
                  {
                    key: "h",
                    label: "Itik",
                    type: "text",
                  },
                  {
                    key: "i",
                    label: "Itik Manila",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);
            const g = num(row.g);
            const h = num(row.h);
            const i = num(row.i);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              g,
              h,
              i,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 10) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan" },
                { label: "Jumlah Desa/Kelurahan Tedampak" },
                { label: "Jumlah Desa/Kelurahan Terkendali" },
                { label: "Luas Desa/Kelurahan Tedampak" },
                { label: "Luas Desa/Kelurahan Terkendali" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["kecamatan", "a", "b", "c","d", "keterangan"],
            sumColumns: ["a", "b", "c","d"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 2,
                fields: [
                  { key: "a",
                    label: "Jumlah Desa/Kelurahan Terdampak",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Jumlah Desa/Kelurahan Terkendali",
                    type: "text",
                  },
                  { key: "c",
                    label: "Luas Desa/Kelurahan Terdampak",
                    type: "text",
                  },
                  {
                    key: "d",
                    label: "Luas Desa/Kelurahan Terkendali",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 11) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama Desa/Kelurahan" },
                { label: "Luas Wilayah" },
                { label: "Jenis PHMS" },
                { label: "Jenis Penanganan" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "a", "phms", "jenis", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Desa/Kelurahan",
                    type: "text",
                  },
                  {
                    key: "a",
                    label: "Luas Wilayah",
                    type: "text",
                  },
                  { key: "phms",
                    label: "Jenis PHMS",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Jenis Penanganan",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 12) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama Desa/Kelurahan" },
                { label: "Luas Wilayah" },
                { label: "Jenis PHMS" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "a", "phms", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Desa/Kelurahan",
                    type: "text",
                  },
                  {
                    key: "a",
                    label: "Luas Wilayah",
                    type: "text",
                  },
                  { key: "phms",
                    label: "Jenis PHMS",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DTPHP + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "DTPHPData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DTPHP + "indikator", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Tanaman Pangan, Hortikultura dan Perkebunan</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DTPHP + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DTPHP + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DTPHP + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.nama = data.nama;
      this.form.phms = data.phms;
      this.form.jenis = data.jenis;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.e = data.e;
      this.form.f = data.f;
      this.form.g = data.g;
      this.form.h = data.h;
      this.form.i = data.i;
      this.form.j = data.j;
      this.form.k = data.k;
      this.form.l = data.l;
      this.form.m = data.m;
      this.form.n = data.n;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
